import { Notification } from "element-ui";

/** 与样式 {@link ../styles/assistant-message.css} 中的类名一致 */
export const ASSISTANT_NOTIFY_CLASS = "assistant-el-notification-center";

const typeTitleEnum = {
    success: "成功",
    warning: "警告",
    error: "错误",
    info: "信息",
};

const defaults = () => ({
    customClass: ASSISTANT_NOTIFY_CLASS,
    duration: 5000,
    showClose: true,
    /* 占位，实际位置由 assistant-message.css 覆盖为视口居中 */
    position: "top-right",
});

function defaultDurationByType(type) {
    // 成功提示更短，避免遮挡操作
    if (type === "success") return 2000;
    return 5000;
}

function normalizeOptions(raw) {
    if (typeof raw === "string") {
        return { message: raw };
    }
    const o = { ...raw };
    if (o.message == null && o.title != null) {
        o.message = o.title;
        delete o.title;
    }
    return o;
}

/**
 * 助手模块专用：与全局 myNotification 一致的 Notification 卡片样式，但显示在视口中部（项目内 $message 被全局替换为 Notification 且靠右上角）
 */
function assistantMessage(input) {
    const merged = normalizeOptions(input);
    const typ = merged.type || "info";
    return Notification({
        ...defaults(),
        ...merged,
        type: typ,
        duration:
            merged.duration != null
                ? merged.duration
                : defaultDurationByType(typ),
        title:
            merged.title != null
                ? merged.title
                : typeTitleEnum[typ] || typeTitleEnum.info,
    });
}

["success", "warning", "info", "error"].forEach((t) => {
    assistantMessage[t] = (input) => {
        if (typeof input === "string") {
            return Notification({
                ...defaults(),
                type: t,
                title: typeTitleEnum[t],
                message: input,
                duration: defaultDurationByType(t),
            });
        }
        const merged = normalizeOptions(input);
        const typ = merged.type || t;
        return Notification({
            ...defaults(),
            ...merged,
            type: typ,
            duration:
                merged.duration != null
                    ? merged.duration
                    : defaultDurationByType(typ),
            title:
                merged.title != null
                    ? merged.title
                    : typeTitleEnum[typ] || typeTitleEnum[t],
        });
    };
});

/**
 * axios 拦截器用：与助手页 `$assistantMessage` 表现一致
 * @param {{ type?: string, title?: string, message?: string }} opts
 */
export function assistantApiMessage(opts = {}) {
    const { type = "error", title, message: msg } = opts;
    const text = msg != null && msg !== "" ? msg : title;
    if (text == null || text === "") {
        return;
    }
    const body = typeof text === "string" ? text : String(text);
    Notification({
        ...defaults(),
        type,
        title: typeTitleEnum[type] || typeTitleEnum.error,
        message: body,
    });
}

export default assistantMessage;
